'use client';
/** Тег `textarea` всегда содержат внутри себя scroll, он может быть лишь скрыт. */ const alwaysContainsScroll = (node)=>node.tagName === 'TEXTAREA';
/** Проверяет, можно ли выполнять прокрутку над элементом. */ const canBeScrolled = (node, overflow)=>{
    if (!(node instanceof Element)) {
        return false;
    }
    const styles = window.getComputedStyle(node);
    return styles[overflow] !== 'hidden' && !(styles.overflowY === styles.overflowX && !alwaysContainsScroll(node) && styles[overflow] === 'visible');
};
/** Проверяет, можно ли выполнять вертикальную прокрутку над элементом. */ const canBeVerticallyScrolled = (node)=>canBeScrolled(node, 'overflowY');
/** Проверяет, можно ли выполнять горизонтальную прокрутку над элементом. */ const canBeHorizontallyScrolled = (node)=>canBeScrolled(node, 'overflowX');

export { canBeHorizontallyScrolled, canBeVerticallyScrolled };
//# sourceMappingURL=canBeScrolled.js.map
